import {
  Box,
  Pressable,
  Toast as NBToast,
  usePropsResolution,
} from 'native-base';
import type { IToastProps } from './Toast.types';
import { CloseOutlined, InfoCircleOutlined } from '../Icon';
import React from 'react';
import { Text } from '../Text';
import { Link } from '../Link';

export const Toast: React.FunctionComponent<IToastProps> = ({
  children,
  icon,
  id,
  onPressAction,
  actionText,
  ...rest
}) => {
  const { _description, _container, _icon, _dismiss, _undo } =
    usePropsResolution('Toast', rest);

  const handlePress = () => {
    const closeToast = onPressAction?.(id);
    if (id && NBToast.isActive(id) && closeToast) {
      NBToast.close(id);
    }
  };

  return (
    <Box {..._container}>
      {icon && <InfoCircleOutlined {..._icon} />}
      <Text {..._description}>{children}</Text>
      {onPressAction && !actionText && (
        <Pressable onPress={handlePress}>
          <CloseOutlined {..._dismiss} />
        </Pressable>
      )}
      {onPressAction && actionText && (
        <Link {..._undo} onPress={handlePress}>
          {actionText}
        </Link>
      )}
    </Box>
  );
};
